<template>
  <!-- Static navbar -->
  <div class="navbar navbar-default navbar-fixed-top navbar-holding-logo text-center" id="main-nav" role="navigation">
    <div class="container-fluid">
      <button type="button" class="navbar-toggle pull-left" style="margin-left:0;" data-toggle="collapse" data-target=".side-collapse">
        <span class="sr-only">Toggle navigation</span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </button>
      <div class="navbar-header">

        <router-link title="GroTec Home" :to="{name:'home'}">
          <img id="logoHolder" src="/img/grotec-text.png" alt="Grotec" title="Grotec" />
        </router-link>

        <router-link :to="{name:'checkout'}" class="btn mobile-tel btn-success hidden-md hidden-lg hidden-sm pull-right">
          <i class="fa fa-shopping-cart"></i>
        </router-link>
      </div>
      <div class="navbar-collapse collapse right-navbar-collapse">
        <ul class="nav navbar-nav navbar-right">
          <li class="text-right">
            <router-link :to="{name:'reserve-collection'}" class="bg-info"  title="Reserve a Collection">
              Reserve a Collection
              <span class="glyphicon glyphicon-briefcase"></span>
            </router-link>
          </li>
          <li class="text-right"><router-link title="tel : 01706 750 293" :to="{name : 'contact'}">Contact</router-link></li>
          <li class="text-right">
            <router-link title="Shopping Cart" :to="{name: 'checkout'}">Cart</router-link>
          </li>
        </ul>
      </div><!--/.nav-collapse -->
    </div>
  </div>
</template>
<script>
  import DepartmentsDropdown from "../departments/departments-dropdown";
  export default {
    name: 'top-bar',
    components: { DepartmentsDropdown },
    data() {
      return {

      }
    }
  }
</script>